const applyTheme = theme => {
  let sheet = document.adoptedStyleSheets.find(s => s.__themeSheet);
  if (!sheet) {
    sheet = new CSSStyleSheet();
    sheet.__themeSheet = true;
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
  }
  const css = `:root {${Object.keys(theme).map(key => `${key}: ${theme[key]};`).join('')}}`;
  sheet.replaceSync(css);
};

export default applyTheme;